import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 20 20"

const PaymentIcon = createSvgIcon(
  <>
    <path
      xmlns='http://www.w3.org/2000/svg'
      className='st0'
      d='M9.3,15.5h1.4v-1c0.7-0.1,1.2-0.4,1.7-0.9c0.4-0.5,0.7-1,0.7-1.6s-0.2-1.2-0.6-1.6c-0.4-0.4-1-0.8-1.8-1.1  C9.9,9,9.3,8.7,9,8.5C8.8,8.3,8.6,8,8.6,7.7C8.6,7.4,8.7,7.2,9,7c0.2-0.2,0.6-0.3,0.9-0.3c0.4,0,0.7,0.1,1,0.3  c0.3,0.2,0.5,0.4,0.6,0.8l1.2-0.5c-0.2-0.5-0.4-0.8-0.8-1.2c-0.4-0.3-0.8-0.5-1.3-0.6v-1H9.3v1C8.7,5.6,8.2,5.9,7.8,6.3  S7.2,7.2,7.2,7.7c0,0.6,0.2,1.2,0.6,1.6s1.1,0.8,2,1.1c0.6,0.2,1.1,0.5,1.4,0.7s0.4,0.5,0.4,0.9c0,0.4-0.1,0.7-0.4,0.9  c-0.3,0.2-0.7,0.4-1.1,0.4c-0.5,0-0.9-0.2-1.2-0.5s-0.6-0.7-0.7-1.2l-1.3,0.5c0.2,0.6,0.5,1.1,0.9,1.5c0.4,0.4,0.9,0.7,1.5,0.8V15.5  z M10,18c-1.1,0-2.1-0.2-3.1-0.6s-1.8-1-2.6-1.7c-0.7-0.7-1.3-1.6-1.7-2.6S2,11.1,2,10c0-1.1,0.2-2.1,0.6-3.1s1-1.8,1.7-2.5  S5.9,3,6.9,2.6S8.9,2,10,2c1.1,0,2.1,0.2,3.1,0.6s1.8,1,2.5,1.7c0.7,0.7,1.3,1.6,1.7,2.5c0.4,1,0.6,2,0.6,3.1c0,1.1-0.2,2.1-0.6,3.1  c-0.4,1-1,1.8-1.7,2.6c-0.7,0.7-1.6,1.3-2.5,1.7S11.1,18,10,18z M10,16.5c1.8,0,3.3-0.6,4.6-1.9s1.9-2.8,1.9-4.6s-0.6-3.3-1.9-4.6  S11.8,3.5,10,3.5S6.7,4.1,5.4,5.4S3.5,8.2,3.5,10s0.6,3.3,1.9,4.6S8.2,16.5,10,16.5z'
    />
  </>,
  'PaymentIcon'
)

export default PaymentIcon
